import { create } from "zustand";

type Severity = "success" | "error" | "info" | "warning";

interface Toast {
  id: number;
  message: string;
  severity: Severity;
}

interface ToastState {
  queue: Toast[];
  push: (message: string, severity?: Severity) => void;
  shift: () => void;
}

let nextId = 1;

export const useToastStore = create<ToastState>((set) => ({
  queue: [],
  push(message, severity = "info") {
    set((state) => ({
      queue: [...state.queue, { id: nextId++, message, severity }],
    }));
  },
  shift() {
    set((state) => ({ queue: state.queue.slice(1) }));
  },
}));
